import { DropdownOption } from "./suggestedRiskFilterDropdown.type"

export enum SuggestedRiskQuickFilterNames {
  Category = 'riskCategory',
  Relevance = 'relevance',
  Impact = 'impactRange',
  RiskImpactTypes = 'riskImpactTypes',
}

export type SuggestedRiskAppliedFilters = {
  impactRange: DropdownOption[],
  likelihoodRange: DropdownOption[],
  riskCategory: DropdownOption[],
  relevance: DropdownOption[],
  riskImpactTypes: DropdownOption[],
  keywords: string[],
  limit: number,
  venueType: DropdownOption[],
  eventType: DropdownOption[],
}
